module.exports = __webpack_public_path__ + "static/media/logo-agente.8791e5f0.svg";